export default "__VITE_ASSET__DdKoRZhn__"